// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d-row {
  display: flex;
  flex-direction: row;
}

.d-col {
  display: flex;
  flex-direction: column;
}

h4 {
  font-size: 1.5em;
  color: #064361;
}

.justify-content-between {
  justify-content: space-between;
}

.justify-content-end {
  justify-content: flex-end;
}

.align-items-center {
  align-items: center;
}

.profile-form-input {
  width: 100%;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.04);
}
.profile-form-input .k-input,
.profile-form-input .k-textbox {
  padding: 8px;
  height: 100%;
}

#email-input,
#phone-input {
  width: calc(100% - 40px);
}

.profile-form-group {
  padding-bottom: 12px;
}

@media screen and (max-width: 500px) {
  .profile-form-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .profile-form-field {
    width: 100%;
    max-width: 300px;
  }
  .profile-label {
    width: 100%;
  }
}
@media screen and (min-width: 501px) {
  .profile-form-group {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .profile-form-field {
    width: 70%;
    max-width: 300px;
  }
  .profile-form-field .button-edit {
    float: right;
    border: none;
    background-color: #fafafa;
    color: #004890;
    height: 40px;
    width: 40px;
  }
  .profile-label {
    width: 30%;
    padding-right: 20px;
    text-align: left;
    max-width: 150px;
  }
}
.warning-title {
  font-weight: bold;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/account/components/manage-profile/manage-profile.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AACA;EACI,yBAAA;AAEJ;;AAAA;EACI,mBAAA;AAGJ;;AAAA;EACI,WAAA;EACA,YAAA;EACA,qCAAA;AAGJ;AAFI;;EAEI,YAAA;EACA,YAAA;AAIR;;AADA;;EAEI,wBAAA;AAIJ;;AAFA;EACI,oBAAA;AAKJ;;AAFA;EACI;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;EAKN;EAHE;IACI,WAAA;IACA,gBAAA;EAKN;EAHE;IACI,WAAA;EAKN;AACF;AAFA;EACI;IACI,aAAA;IACA,mBAAA;IACA,mBAAA;EAIN;EAFE;IACI,UAAA;IACA,gBAAA;EAIN;EAFM;IACI,YAAA;IACA,YAAA;IACA,yBAAA;IACA,cAAA;IACA,YAAA;IACA,WAAA;EAIV;EADE;IACI,UAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;EAGN;AACF;AAAA;EACI,iBAAA;EACA,iBAAA;AAEJ","sourcesContent":[".d-row {\n    display: flex;\n    flex-direction: row;\n}\n\n.d-col {\n    display: flex;\n    flex-direction: column;\n}\n\nh4 {\n    font-size: 1.5em;\n    color: #064361;\n}\n\n.justify-content-between {\n    justify-content: space-between;\n}\n.justify-content-end {\n    justify-content: flex-end;\n}\n.align-items-center {\n    align-items: center;\n}\n\n.profile-form-input {\n    width: 100%;\n    height: 40px;\n    background-color: rgba(0, 0, 0, 0.04);\n    .k-input,\n    .k-textbox {\n        padding: 8px;\n        height: 100%;\n    }\n}\n#email-input,\n#phone-input {\n    width: calc(100% - 40px);\n}\n.profile-form-group {\n    padding-bottom: 12px;\n}\n\n@media screen and (max-width: 500px) {\n    .profile-form-group {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n    }\n    .profile-form-field {\n        width: 100%;\n        max-width: 300px;\n    }\n    .profile-label {\n        width: 100%;\n    }\n}\n\n@media screen and (min-width: 501px) {\n    .profile-form-group {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n    }\n    .profile-form-field {\n        width: 70%;\n        max-width: 300px;\n\n        .button-edit {\n            float: right;\n            border: none;\n            background-color: #fafafa;\n            color: #004890;\n            height: 40px;\n            width: 40px;\n        }\n    }\n    .profile-label {\n        width: 30%;\n        padding-right: 20px;\n        text-align: left;\n        max-width: 150px;\n    }\n}\n\n.warning-title {\n    font-weight: bold;\n    margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
